import {
  SITE_AUDIT_CUSTOM_DOMAIN,
  SITE_AUDIT_PROJECT_DOMAIN,
} from '../../utils/consts.mjs'
import { CHANGE_CURRENT_PROJECT } from '../Dashboard/actions'

import {
  CRAWL_SITE_AUDIT,
  GET_LIGHTHOUSE_BENCHMARK,
  GET_PAGES_DISCOVERED,
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  GET_OVERVIEW,
  STOP_SITE_AUDIT,
  GET_ISSUE_BREAKDOWN,
  CRAWL_PARTIAL_SITE_AUDIT,
  DISPLAY_UPGRADE_MODAL,
  CANCEL_SITE_AUDIT,
  CHANGE_SITE_AUDIT_DOMAIN_TYPE,
  GET_PROJECT_SITE_AUDIT_DATA,
  CRAWL_PROJECT_SITE_AUDIT,
  GET_PROJECT_OVERVIEW,
  GET_PROJECT_LIGHTHOUSE_BENCHMARK,
} from './actions'

const initialState = {
  type: SITE_AUDIT_CUSTOM_DOMAIN,
  [SITE_AUDIT_PROJECT_DOMAIN]: {
    domain: null,
    mode: null,
    issue: null,
    isCancelledCrawling: false,
    isCrawling: false,
    isPolling: false,
    stopCrawling: false,
    crawlingProgress: 0,
    crawlingErrorText: null,
    done: false,
    siteAuditData: null,
    partialSiteAudit: {
      crawlingProgress: 0,
      crawlingErrorText: null,
      done: false,
      data: null,
    },
    searchBarError: null,
    organic: undefined,
    backlinks: undefined,
    traffic: undefined,
    lighthouseBenchmark: null,
    pagesDiscovered: {
      isLoading: true,
      data: null,
      pagination: {
        page: 0,
        pageCount: 1,
        pageSize: 50,
      },
    },
    issueBreakdown: {},
    issueIgnored: {},
    issueDiff: {},
    notifications: [],
    displayUpgradeModal: false,
    isLoadingDomainOverview: false,
  },
  [SITE_AUDIT_CUSTOM_DOMAIN]: {
    domain: null,
    mode: null,
    issue: null,
    isCancelledCrawling: false,
    isCrawling: false,
    isPolling: false,
    stopCrawling: false,
    crawlingProgress: 0,
    crawlingErrorText: null,
    done: false,
    siteAuditData: null,
    partialSiteAudit: {
      crawlingProgress: 0,
      crawlingErrorText: null,
      done: false,
      data: null,
    },
    searchBarError: null,
    organic: undefined,
    backlinks: undefined,
    traffic: undefined,
    lighthouseBenchmark: null,
    pagesDiscovered: {
      isLoading: true,
      data: null,
      pagination: {
        page: 0,
        pageCount: 1,
        pageSize: 50,
      },
    },
    issueBreakdown: {},
    issueIgnored: {},
    issueDiff: {},
    notifications: [],
    displayUpgradeModal: false,
    isLoadingDomainOverview: false,
  },
}

const siteAuditReducer = (state = initialState, action = undefined) => {
  let resultState = null

  switch (action.type) {
    case CHANGE_CURRENT_PROJECT.action:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          domain: null,
          mode: null,
          isCancelledCrawling: false,
          isCrawling: false,
          isPolling: false,
          crawlCount: 0,
          crawlingProgress: 0,
          crawlingErrorText: null,
          done: false,
          searchBarError: null,
          siteAuditData: null,
          lighthouseBenchmark: null,
          issueBreakdown: {},
          issueIgnored: [],
          organic: undefined,
          backlinks: undefined,
          traffic: undefined,
          notifications: [],
        },
      }
      break
    case CRAWL_SITE_AUDIT.action:
      resultState = {
        ...state,
        type: action.payload.type,
        [action.payload.type]: {
          ...state[action.payload.type],
          domain: action.payload.domain,
          mode: action.payload.mode,
          isCancelledCrawling: false,
          isCrawling: true,
          isPolling: false,
          crawlCount: 0,
          crawlingProgress: 0,
          crawlingErrorText: null,
          done: false,
          searchBarError: null,
          siteAuditData: null,
          lighthouseBenchmark: null,
          issueBreakdown: {},
          issueIgnored: [],
          organic: undefined,
          backlinks: undefined,
          traffic: undefined,
          notifications: [],
        },
      }
      break
    case CRAWL_SITE_AUDIT.polling:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
          isPolling: true,
        },
      }
      break
    case CRAWL_SITE_AUDIT.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
          isPolling: false,
        },
      }
      break
    case CRAWL_SITE_AUDIT.failed:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
          isPolling: false,
        },
      }
      break
    case CRAWL_PARTIAL_SITE_AUDIT.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          partialSiteAudit: {
            isCrawling: false,
            crawlingProgress: 0,
            crawlingErrorText: null,
            done: false,
            data: null,
          },
        },
      }
      break
    case CRAWL_PARTIAL_SITE_AUDIT.polling:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          partialSiteAudit: {
            ...action.payload,
          },
        },
      }
      break
    case CRAWL_PARTIAL_SITE_AUDIT.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          partialSiteAudit: {
            ...action.payload.partialSiteAudit,
          },
          siteAuditData: action.payload.siteAuditData,
        },
      }
      break
    case CRAWL_PARTIAL_SITE_AUDIT.failed:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          partialSiteAudit: {
            ...action.payload,
          },
        },
      }
      break
    case STOP_SITE_AUDIT.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          stopCrawling: true,
          isPolling: false,
        },
      }
      break
    case STOP_SITE_AUDIT.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
          stopCrawling: false,
          isPolling: false,
        },
      }
      break
    case GET_OVERVIEW.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          isLoadingDomainOverview: true,
        },
      }
      break
    case GET_OVERVIEW.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
          isLoadingDomainOverview: false,
        },
      }
      break
    case GET_OVERVIEW.failed:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          organic: null,
          traffic: null,
          backlinks: null,
          isLoadingDomainOverview: false,
        },
      }
      break
    case GET_LIGHTHOUSE_BENCHMARK.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          lighthouseBenchmark: action.payload,
        },
      }
      break
    case GET_LIGHTHOUSE_BENCHMARK.failed:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          lighthouseBenchmark: {},
        },
      }
      break
    case GET_PAGES_DISCOVERED:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          pagesDiscovered: {
            ...state.pagesDiscovered,
            isLoading: true,
          },
        },
      }
      break
    case GET_PAGES_DISCOVERED.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          pagesDiscovered: action.payload,
        },
      }
      break
    case GET_PAGES_DISCOVERED.failed:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          pagesDiscovered: {
            ...state[state.type].pagesDiscovered,
            isLoading: false,
          },
        },
      }
      break
    case GET_ISSUE_BREAKDOWN.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          issue: action.payload.issue,
          hideIssues: action.payload.hideIssues,
        },
      }
      break
    case GET_ISSUE_BREAKDOWN.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
        },
      }
      break
    case GET_ISSUE_BREAKDOWN.failed:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          ...action.payload,
        },
      }
      break
    case ADD_NOTIFICATION.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          notifications: [...state.notifications, action.payload],
        },
      }
      break
    case REMOVE_NOTIFICATION.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          notifications: state.notifications.filter(
            (notification) => notification.id !== action.payload?.id,
          ),
        },
      }
      break
    case DISPLAY_UPGRADE_MODAL.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          displayUpgradeModal: true,
        },
      }
      break
    case DISPLAY_UPGRADE_MODAL.success:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          displayUpgradeModal: false,
        },
      }
      break
    case CANCEL_SITE_AUDIT.action:
      resultState = {
        ...state,
        [state.type]: {
          ...state[state.type],
          isCancelledCrawling: true,
        },
      }
      break
    case CHANGE_SITE_AUDIT_DOMAIN_TYPE.action:
      resultState = {
        ...state,
        type: action.siteAuditDomainType,
      }
      break
    case GET_PROJECT_SITE_AUDIT_DATA.action:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          domain: action.payload.domain,
          mode: action.payload.mode,
          isCancelledCrawling: false,
          isCrawling: true,
          isPolling: false,
          crawlCount: 0,
          crawlingProgress: 0,
          crawlingErrorText: null,
          done: false,
          searchBarError: null,
          siteAuditData: null,
          lighthouseBenchmark: null,
          issueBreakdown: {},
          issueIgnored: [],
          organic: undefined,
          backlinks: undefined,
          traffic: undefined,
          notifications: [],
        },
      }
      break
    case CRAWL_PROJECT_SITE_AUDIT.polling:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          ...action.payload,
          isPolling: true,
        },
      }
      break
    case CRAWL_PROJECT_SITE_AUDIT.failed:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          ...action.payload,
          isPolling: false,
        },
      }
      break
    case CRAWL_PROJECT_SITE_AUDIT.success:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          ...action.payload,
          isPolling: false,
        },
      }
      break
    case GET_PROJECT_OVERVIEW.action:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          isLoadingDomainOverview: true,
        },
      }
      break
    case GET_PROJECT_OVERVIEW.success:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          ...action.payload,
          isLoadingDomainOverview: false,
        },
      }
      break
    case GET_PROJECT_OVERVIEW.failed:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          organic: null,
          traffic: null,
          backlinks: null,
          isLoadingDomainOverview: false,
        },
      }
      break
    case GET_PROJECT_LIGHTHOUSE_BENCHMARK.success:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          lighthouseBenchmark: action.payload,
        },
      }
      break
    case GET_PROJECT_LIGHTHOUSE_BENCHMARK.failed:
      resultState = {
        ...state,
        [SITE_AUDIT_PROJECT_DOMAIN]: {
          ...state[SITE_AUDIT_PROJECT_DOMAIN],
          lighthouseBenchmark: {},
        },
      }
      break
    default:
      return state
  }

  if (!resultState) {
    resultState = {
      ...state,
    }
  }
  return resultState
}

export default siteAuditReducer
